import React from "react";

const SelectDropdown = ({
  header,
  options,
  name,
  icon,
  onChange,
  onBlur,
  value,
  error,
}) => {
  // const handleChange = (e) => {
  //   const value = e.target.value;
  //   setState((state) => ({ ...state, [name]: value }));
  // };

  return (
    <div className="flex items-center ">
      {header && <h2 className="font-semibold mr-4">{header}</h2>}
      <div
        className={
          header
            ? "relative inline-block w-2/4"
            : "relative inline-block w-full"
        }
      >
        <div
          class={
            error
              ? "absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none text-red-500 text-[18px]"
              : "absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none text-[#6b7280] text-[18px]"
          }
        >
          {icon}
        </div>
        <select
          id={name}
          name={name}
          className={
            error
              ? "bg-red-50 border border-red-500 text-red-900 text-sm rounded-lg focus:none focus:none block w-full  ps-10 p-2.5"
              : "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 mt-2"
          }
          onChange={onChange}
          onBlur={onBlur}
          value={value}
        >
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {/* <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
        <svg
          className="fill-current h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path d="M7 7l3-3 3 3H7z" />
        </svg>
      </div> */}
      </div>
    </div>
  );
};

export default SelectDropdown;
